// src/component/login/AdminLogin.jsx
import React, { useState } from "react";
import { Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [admin, setAdmin] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setAdmin({ ...admin, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    try {
      const res = await fetch("http://localhost:5000/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(admin),
      });

      const data = await res.json();

      if (!res.ok) {
        return message.error(data.message || "Login failed");
      }

      const tokenData = JSON.parse(atob(data.token.split('.')[1]));
      if (tokenData.role !== "admin") {
        return message.error("Access denied. Not an admin.");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(tokenData));
      message.success("Welcome, Admin!");
      navigate("/admin/dashboard");
    } catch (err) {
      console.error(err);
      message.error("Server error");
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "auto", marginTop: 100 }}>
      <h2>Admin Login</h2>
      <Input
        name="email"
        placeholder="Admin Email"
        value={admin.email}
        onChange={handleChange}
        style={{ marginBottom: 10 }}
      />
      <Input.Password
        name="password"
        placeholder="Password"
        value={admin.password}
        onChange={handleChange}
        style={{ marginBottom: 10 }}
      />
      <Button type="primary" onClick={handleLogin} block>
        Login as Admin
      </Button>
    </div>
  );
};

export default AdminLogin;
